var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisteredStudentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "2.5rem",
    viewBox: "0 0 45 51.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-graduate-solid",
    d: "M21.986.1a2.488,2.488,0,0,1,.944,0L43.017,4.113a2.406,2.406,0,0,1,0,4.721l-7.7,1.547v5.735a12.856,12.856,0,1,1-25.712,0V10.38L4.781,9.416v6.538l1.577,7.874a1.637,1.637,0,0,1-.331,1.336,1.612,1.612,0,0,1-1.245.593H1.567a1.6,1.6,0,0,1-1.245-.593A1.577,1.577,0,0,1-.01,23.828l1.577-7.874V8.743A2.406,2.406,0,0,1,1.9,4.113ZM11.2,32.958a2.868,2.868,0,0,1,2.953.854l7.131,7.583a1.609,1.609,0,0,0,2.34,0l7.131-7.583a2.868,2.868,0,0,1,2.953-.854A16.206,16.206,0,0,1,44.955,48.385a3.084,3.084,0,0,1-3.083,3.083H3.043A3.091,3.091,0,0,1-.04,48.385,16.21,16.21,0,0,1,11.2,32.958Z",
    transform: "translate(0.045 -0.05)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisteredStudentsIcon);
export default __webpack_public_path__ + "static/media/registered-students-icon.ede7e6c1394326d69058786185382f89.svg";
export { ForwardRef as ReactComponent };